import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Modal, Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from 'react-select';

import { StyledButton } from '../UI';

import './banner.modules.css';

import CheckBox from '../UI/CheckBox/CheckBox';

const BannerItemModal = ({ banner = null, projectId = null, localizationId = null, showModal, setShowModal, onSaveChangesHandler }) => {
    const initialState = {
        id: null,
        created: null,
        updated: null,
        name: '',
        description: '',
        bannerGuid: null,
        projectId: null,
        isArchive: false,
        maximumNumberOfEvents: 0,
        sports: [],
        disciplines: [],
        tournamentsIdString: '', //array of int in string separated with comma
        tournaments: [], //array of int in string separated with comma
        events: '', //array of int in string separated with comma
        prospectTypes: [],
        eventTypes: [],
        periods: '', //array of int in string separated with comma
        sportEvents: [],
        allMarkets: false,
        haveTranslation: false,
        countryId: '',
        opponents: '', //array of int in string separated with comma
        partnerLink: '',
        languages: [],
        dateFrom: null,
        dateTo: null,
        bannerEventType: 0 //0 - line, 1 - live
    };

    const dispatch = useDispatch();
    const [bannerItem, setBannerItem] = useState(initialState);
    const dictionariesLanguage = useSelector(state => state.catalogs.languages.find(language => language.id === localizationId));
    const isEditMode = banner ? true : false;
    const dictionaries = useSelector(state => state.catalogs);
    const localizations = dictionaries.languages.map(x => ({ value: x.id, label: x.name }));
    const sports = dictionaries.sports.filter(x => x.languageId === localizationId).map(x => ({ value: x.id, label: x.name }));
    const disciplines = dictionaries.disciplines.filter(x => x.languageId === localizationId).map(x => ({ value: x.id, label: x.name }));
    const prospectTypes = dictionaries.prospectTypes.filter(x => x.languageId === localizationId && x.name.length > 0).map(x => ({ value: x.id, label: x.name }));
    const eventTypes = dictionaries.eventTypes.filter(x => x.languageId === localizationId && x.name.length > 0).map(x => ({ value: x.id, label: x.name }));
    const sportEvents = dictionaries.sportEvents.filter(x => x.languageId === localizationId && x.name.length > 0).map(x => ({ value: x.id, label: x.name }));
    const bannerEventsTypes = [{ value: 0, label: "Line" }, { value: 1, label: "Live" }];
    const [subMenuItem, setSubMenuItem] = useState('Основные');

    //подменю основные и дополнительные параметры
    const onChangeSubMenuItem = (menuItem) => {
        //console.log(menuItem.target);

        setSubMenuItem(menuItem);
    };

    
    //console.log('localizationId', localizationId);
    //console.log('projectId', projectId);
    //console.log('dictionariesLanguage', dictionariesLanguage);
    //console.log('catalogs', dictionaries);
    //useEffect(() => {
    //    if (showModal === false)
    //        setSubMenuItem('Основные');
    //}, [showModal]);
    
    const commaIdArrayParse = (currentString) => {
        let arrayItems = currentString.split(',');
        arrayItems.forEach(item => {
            item = parseInt(item) || 0;
        });

        let newString = '';
        arrayItems.forEach(item => {
            newString += item;
        });

        return newString;
    };

    useEffect(() => {
        setBannerItem(banner ? banner : { ...initialState, projectId: projectId });
    },[banner, projectId]);

    const onChangeNameHandler = ({ value }) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.name = value;
            return newState;
        });
    };

    const onChangeDescriptionHandler = ({ value }) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.description = value;
            return newState;
        });
    };

    const onChangeMaximumNumberOfEventsHandler = ({ value }) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.maximumNumberOfEvents = parseInt(value) || 0;
            return newState;
        });
    };

    const onSelectLocalizationsHandler = (value) => {
        setBannerItem(state => {
            const newState = { ...state };
            const newLanguages = value.map(x => {
                return dictionaries.languages.find(l => l.id == x.value);
            });
            newState.languages = newLanguages;
            return newState;
        });
    };

    const onSelectSportHandler = (value) => {
        setBannerItem(state => {
            const newState = { ...state };
            const newList = value.map(x => {
                return dictionaries.sports.find(l => l.id == x.value);
            });
            newState.sports = newList;
            return newState;
        });
    };

    const onSelectDisciplineHandler = (value) => {
        setBannerItem(state => {
            const newState = { ...state };
            const newList = value.map(x => {
                return dictionaries.disciplines.find(l => l.id == x.value);
            });
            newState.disciplines = newList;
            return newState;
        });
    };

    const onSelectSportEventsHandler = (value) => {
        setBannerItem(state => {
            const newState = { ...state };
            const newList = value.map(x => {
                return dictionaries.sportEvents.find(l => l.id == x.value);
            });
            newState.sportEvents = newList;
            return newState;
        });
    };

    const onSelectProspectTypesHandler = (value) => {
        setBannerItem(state => {
            const newState = { ...state };
            const newList = value.map(x => {
                return dictionaries.prospectTypes.find(l => l.id == x.value);
            });
            newState.prospectTypes = newList;
            return newState;
        });
    };

    const onSelectEventTypesHandler = (value) => {
        setBannerItem(state => {
            const newState = { ...state };
            const newList = value.map(x => {
                return dictionaries.eventTypes.find(l => l.id == x.value);
            });
            newState.eventTypes = newList;
            return newState;
        });
    };

    const onChangeTournamentsHandler = ({ value }) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.tournamentsIdString = value;
            return newState;
        });
    };

    const onChangePeriodsHandler = ({ value }) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.periods = value;
            return newState;
        });
    };

    const onChangePartnerLinkHandler = ({ value }) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.partnerLink = value;
            return newState;
        });
    };

    const onChangeEventsHandler = ({ value }) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.events = value;
            return newState;
        });
    };

    const onChangeOpponentskHandler = ({ value }) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.opponents = value;
            return newState;
        });
    };

    const onSelectBannerEventTypeHandler = (x) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.bannerEventType = x.value;
            return newState;
        });
    };

    const onChangeAllMarkets = (value) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.allMarkets = value;
            return newState;
        });
    };

    const onChangeHaveTranslation = (value) => {
        setBannerItem(state => {
            const newState = { ...state };
            newState.haveTranslation = value;
            return newState;
        });
    };

    const onChangeСountryIdHandler = ({ value }) => {
        const intValue = parseInt(value) || 0;

        setBannerItem(state => {
            const newState = { ...state };
            newState.countryId = intValue === 0 ? '' : intValue;
            return newState;
        });
    };

    const onSaveHandler = () => {
        onSaveChangesHandler({ ...bannerItem, countryId: (bannerItem.countryId?.length === 0 ? null : bannerItem.countryId) });
        setBannerItem({ ...initialState, projectId: projectId });
        setShowModal(false);
        setTimeout(() => {
            setSubMenuItem('Основные');
        }, 300);
    };

    const onCancelHandler = () => {
        setBannerItem({ ...initialState, projectId: projectId });
        setShowModal(false);
        setTimeout(() => {
            setSubMenuItem('Основные');
        }, 300);
    };

    const customStyles = {
        //option: (provided, state) => ({
        //    ...provided,
        //    //borderBottom: '1px dotted pink',
        //    color: state.isSelected ? 'red' : 'blue',
        //    //padding: 20,
        //}),
        control: (provided) => ({
            ...provided,
            border: '1px solid red'
            // none of react-select's styles are passed to <Control />
            //width: 200,
        }),
        //singleValue: (provided, state) => {
        //    const opacity = state.isDisabled ? 0.5 : 1;
        //    const transition = 'opacity 300ms';

        //    return { ...provided, opacity, transition };
        //};
    };

    return (
        <Modal
            isOpen={showModal}
            //toggle={() => setShowModal(false)}
            toggle={onCancelHandler}
        >
            <ModalHeader
                //toggle={() => setShowModal(false)}
                toggle={onCancelHandler}
            >
                <div className='modalHeaderAdditional'>
                    <div className="modalHeaderName">
                        {isEditMode ? "Редактировать запрос" : "Добавить новый запрос"}
                    </div>
                    <div className="modalHedaerMenu">
                        Параметры:
                        <div onClick={() => onChangeSubMenuItem('Основные')} className={`modalHeaderMenuItem ${subMenuItem === 'Основные' ? 'selected' : ''}`}>Основные</div>
                        <div onClick={() => onChangeSubMenuItem('Дополнительные')} className={`modalHeaderMenuItem ${subMenuItem === 'Дополнительные' ? 'selected' : ''}`}>Дополнительные</div>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
                {subMenuItem === 'Основные' ?
                    <>
                        <div className="modal-row">
                            <div className='row-name'>Наименование:</div>
                            <div className='row-input'><Input value={bannerItem.name} onChange={e => onChangeNameHandler(e.target)} /></div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Описание:</div>
                            <div className='row-input'><Input value={bannerItem.description} onChange={e => onChangeDescriptionHandler(e.target)} /></div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Вид запросов:</div>
                            <div className='row-input'>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    defaultValue={bannerEventsTypes[0]}
                                    value={bannerEventsTypes.find(p => p.value == parseInt(bannerItem.bannerEventType))}
                                    isDisabled={false}
                                    isLoading={false}
                                    isClearable={false}
                                    isRtl={false}
                                    isSearchable={true}
                                    name="bannerEventType"
                                    options={bannerEventsTypes}
                                    onChange={onSelectBannerEventTypeHandler}
                                />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Локализации:</div>
                            <div className='row-input'>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={bannerItem.languages.map(x => { return localizations.find(l => l.value == x.id) })}
                                    isMulti
                                    placeholder="Выберите локализации"
                                    isLoading={false}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={true}
                                    name="localizations"
                                    options={localizations}
                                    onChange={onSelectLocalizationsHandler}
                                //styles={customStyles}
                                />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Макс. кол-во событий:</div>
                            <div className='row-input'><Input value={bannerItem.maximumNumberOfEvents} onChange={e => onChangeMaximumNumberOfEventsHandler(e.target)} /></div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Спорт:</div>
                            <div className='row-input'>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={bannerItem.sports.map(x => { return sports.find(l => l.value == x.id) })}
                                    isMulti
                                    placeholder="Выберите спорты"
                                    isLoading={false}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={true}
                                    name="sports"
                                    options={sports}
                                    onChange={onSelectSportHandler}
                                />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Дисциплины (киберспорт):</div>
                            <div className='row-input'>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={bannerItem.disciplines.map(x => { return disciplines.find(l => l.value == x.id) })}
                                    isMulti
                                    placeholder="Выберите дисциплины"
                                    isLoading={false}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={true}
                                    name="disciplines"
                                    options={disciplines}
                                    onChange={onSelectDisciplineHandler}
                                />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Ид турниров:</div>
                            <div className='row-input'><Input placeholder='Пример: 1,2,3' value={bannerItem.tournamentsIdString} onChange={e => onChangeTournamentsHandler(e.target)} /></div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Ид событий:</div>
                            <div className='row-input'><Input placeholder='Пример: 1,2,3' value={bannerItem.events} onChange={e => onChangeEventsHandler(e.target)} /></div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Виды событий:</div>
                            <div className='row-input'>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={bannerItem.prospectTypes.map(x => { return prospectTypes.find(l => l.value == x.id) })}
                                    isMulti
                                    placeholder="Выберите виды событий"
                                    isLoading={false}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={true}
                                    name="prospectTypes"
                                    options={prospectTypes}
                                    onChange={onSelectProspectTypesHandler}
                                />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Типы событий:</div>
                            <div className='row-input'>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={bannerItem.eventTypes.map(x => { return eventTypes.find(l => l.value == x.id) })}
                                    isMulti
                                    placeholder="Выберите типы событий"
                                    isLoading={false}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={true}
                                    name="eventTypes"
                                    options={eventTypes}
                                    onChange={onSelectEventTypesHandler}
                                />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>ИД периодов:</div>
                            <div className='row-input'><Input placeholder='Пример: 1,2,3' value={bannerItem.periods} onChange={e => onChangePeriodsHandler(e.target)} /></div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Маркеты:</div>
                            <div className='row-input'>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={bannerItem.sportEvents.map(x => { return sportEvents.find(l => l.value == x.id) })}
                                    isMulti
                                    placeholder="Выберите маркеты"
                                    isLoading={false}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={true}
                                    name="sportEvents"
                                    options={sportEvents}
                                    onChange={onSelectSportEventsHandler}
                                />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>Партнерская ссылка:</div>
                            <div className='row-input'><Input placeholder='' value={bannerItem.partnerLink} onChange={e => onChangePartnerLinkHandler(e.target)} /></div>
                        </div>
                    </>
                    :
                    <>
                        <div className="modal-row">
                            <CheckBox checked={bannerItem.allMarkets} label="Получить все маркеты:" onClick={onChangeAllMarkets} />
                        </div>
                        <div className="modal-row">
                            <CheckBox checked={bannerItem.haveTranslation} label="Наличие трансляции:" onClick={onChangeHaveTranslation} />
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>ИД страны-геопозиции клиента:</div>
                            <div className='row-input'><Input placeholder='Пример: 17' value={bannerItem.countryId} onChange={e => onChangeСountryIdHandler(e.target)} /></div>
                        </div>
                        <div className="modal-row">
                            <div className='row-name'>ИД оппонетнов:</div>
                            <div className='row-input'><Input placeholder='Пример: 1,2,3' value={bannerItem.opponents} onChange={e => onChangeOpponentskHandler(e.target)} /></div>
                        </div>
                    </>
                }

            </ModalBody>
            <ModalFooter>
                <Button
                    color="primary"
                    onClick={onSaveHandler}
                >
                    Сохранить
                    </Button>
                {' '}
                <Button onClick={onCancelHandler}>
                    Отменить
                    </Button>
            </ModalFooter>
        </Modal>
    );
};

export default BannerItemModal;